/** Default (restored) width of the list panel, in CSS px. */
export const DEFAULT_LIST_WIDTH = 420

/** Upper bound for the list panel however it's widened — drag, keyboard, or maximize. In CSS px. */
export const MAX_EXPANDED_LIST_WIDTH = 720

/**
 * Widest the list panel is allowed to get, for a given viewport width.
 *
 * Two bounds, both needed:
 *   - 30% of the viewport, so the map keeps the majority of a narrow window;
 *   - MAX_EXPANDED_LIST_WIDTH, so a wide monitor doesn't let the panel run out to 1000px+. The
 *     cards don't get more readable past ~700px (a two-line title plus a short description).
 * Floored at DEFAULT_LIST_WIDTH so the cap can never come out below the panel's own default width
 * — otherwise a mid-size window would clamp the panel narrower than its restored size, and the
 * maximize button would make it smaller.
 */
export function maxListPanelWidth(viewportWidth: number): number {
  const proportional = Math.round(viewportWidth * 0.3)
  return Math.max(DEFAULT_LIST_WIDTH, Math.min(proportional, MAX_EXPANDED_LIST_WIDTH))
}

/**
 * Width the maximize button jumps the list panel to — the widest allowed, i.e. the same ceiling
 * the divider drag stops at.
 *
 * Deliberately the same function as the cap rather than its own percentage: with two independent
 * formulas (this was `viewportWidth * 0.5` against a 0.3 cap) the preset could land above the cap
 * and get clamped, which left the button's own "am I fully expanded?" check permanently false —
 * so it kept showing Expand after expanding and there was no way back to the default size.
 */
export function fullExpandWidth(viewportWidth: number): number {
  return maxListPanelWidth(viewportWidth)
}
